import t from 'root/i18n';

const ACCESS_TYPE = [
	{ id: 'READ', name: t('ACL.read'), },
	{ id: 'WRITE', name: t('ACL.write'), },
	{ id: 'EXECUTE', name: t('ACL.execute'), },
	{ id: '*', name: t('ACL.all'), },
];

const PRINCIPAL_TYPE = [
	{ id: 'APP', name: t('ACL.app'), },
	{ id: 'ROLE', name: t('ACL.role'), },
	{ id: 'USER', name: t('ACL.user'), },
];

const PERMISSION = [
	{ id: 'ALLOW', name: t('ACL.allow'), },
	{ id: 'DENY', name: t('ACL.deny'), },
];

export default {
	ACCESS_TYPE,
	PRINCIPAL_TYPE,
	PERMISSION,
};
